const recap = {
	subtitle: 'Récapitulatif des informations',
	sections: { project: 'Projet', issuer: 'Émetteur', services: 'Services', tourist: 'Données Touristiques', visuel: 'Visuel et Supports', devices: 'Dispositifs de Lecture', website: 'Site Web', social: 'Réseaux sociaux dédiés au Pass', inscr: 'Inscriptions & Boutique en ligne', finance: 'Gestion financière', various: 'Langues, couleurs et Divers', contacts: 'Contacts', formules: 'Formules' },
	labels: {
		platform: 'Type de plateforme :',
		tourism: 'Tourisme',
		pms: 'PMS',
		nomProjet: 'Nom du projet :',
		nomPass: 'Nom du Pass :',
		territoire: 'Territoire :',
		nomComplet: 'Nom complet :',
		ref: 'Référence :',
		adresse: 'Adresse :',
		cp: 'Code postal :',
		ville: 'Ville :',
		pays: 'Pays :',
		tel: 'Tél. public :',
		site: 'Site Web public :',
		domaine: 'Domaine :',
		emailContact: 'Email public de contact :',
		emailNotif: 'Email de réception des notifications automatiques :',
		fb: 'Facebook :',
		yt: 'Youtube :',
		ig: 'Instagram :',
		x: 'X :',
		servSel: 'Services sélectionnés :',
		servOne: 'Service sélectionné :',
		operator: 'Opérateur :',
		durDiff: "L'offre transport comporte des durées différentes :",
		alu: 'Alimentation base touristique :',
		platef: 'Éditeur plateforme :',
		freq: 'Fréquence synchronisations :',
		visuel: 'Visuel du Pass :',
		supDem: 'Support dématérialisé :',
		supPhys: 'Support physique :',
		recto: 'Identifiant imprimé au recto :',
		verso: 'Identifiant imprimé au verso :',
		aucun: 'aucun',
		presta: 'Prestataires équipés :',
		lect: 'Type de lecture :',
		front: 'Front Otipass commandé :',
		multilang: 'Multilingue',
		langue: 'Langue :',
		ndd: 'Nom de domaine :',
		booked: 'Réservé chez :',
		fbPass: 'Facebook :',
		ytPass: 'Youtube :',
		igPass: 'Instagram :',
		xPass: 'X :',
		non: 'non renseigné',
		existingForm: 'Formulaire existant :',
		url: 'URL :',
		existingShop: 'Boutique existante :',
		non2: 'non',
		non3: 'non',
		languesBo: 'Langues backoffice :',
		non4: 'non renseignées',
		primary: 'Couleur primaire dominante :',
		non5: 'non renseignée',
		secondary: 'Couleur secondaire :',
		mobile: 'Application mobile :',
		devises: 'Devises :',
		periodE: 'Périodicité des états sur les entrées :',
		periodV: 'Périodicité des états sur les ventes :',
		non6: 'Non définies',
		usable: 'Utilisable {{d}} jours sur une période glissante de {{p}} jours',
		tarifA: 'Tarif adulte :',
		tarifE: 'Tarif enfant :',
		acc: "Nombre d'accompagnants :",
		formatrix: "Formulaire d'inscription Otipass",
		boutique: 'Boutique Otipass',
		users: 'Données utilisateurs récoltées',
		uid: 'Identité pivot (UID)',
		existing: 'Boutique existante :',
		aucunC: 'Aucun contact',
		euro: '€',
	},
	contact: {
		coordinator: 'Coordinateur.trice du projet',
		technical: "Contact technique intégration Web",
		data: 'Contact intégration données touristiques (Apidae, Tourinsoft)',
		accounting: 'Référent.e comptabilité',
	},
	success: {
		thanks: "Merci d'avoir pris le temps de répondre à nos questions ;)",
		submitted: 'Votre formulaire a été soumis avec succès !',
		saved: 'Les données ont été enregistrées sur notre serveur.',
		printHint: 'Vous pouvez maintenant imprimer le récapitulatif de votre configuration.',
		printBtn: 'Imprimer le récapitulatif',
	},
};

export default recap;
